// URL Prefix
const publicPrefix = `/api/Customer/v1.0.0.1`;

// API URL
export const PATH = {
  VENDING: {
    CHEK_STATUS_VENDING_INFO_TRG: `${publicPrefix}/ToroGo/CheckStatusVendingInfoByToroGo`,
    GET_VENDING_INFO_TRG: `${publicPrefix}/ToroGo/GetVendingInfoByToroGo`,
    GET_LIST_VENDING_TRG: `${publicPrefix}/ToroGo/GetListVendingByToroGo`,
    UPDATE_SYNC_DATA: `${publicPrefix}/ToroGo/UpdateSyncData`,
    GET_ADVERTISE_TRG: `${publicPrefix}/ToroGo/GetAdvertiseByToroGo`,
    GET_ORDER_MACHINE: `${publicPrefix}/ToroGo/GetOrderMachineInfo`,
  },
  PRODUCT: {
    GET_LAYOUT_TRG: `${publicPrefix}/ToroGo/GetLayoutByToroGo`,
    GET_PRODUCT_TRG: `${publicPrefix}/ToroGo/GetProductByToroGo`,
    GET_PRODUCT_GROUP_TRG: `${publicPrefix}/ToroGo/GetProductGroupByToroGo`,
    GET_PROMOTION_TRG: `${publicPrefix}/ToroGo/GetPromotionByToroGo`,
  },
  CART: {
    GET_MEMBER_VOUCHER: `${publicPrefix}/Member/GetVoucherMember`,
    CHECK_VOUCHER: `${publicPrefix}/Voucher/CheckVoucher`,
  },
  BILL: {
    SAVE_BILL: `${publicPrefix}/ToroGo/SaveBillToroGo`,
    CREATE_ORDER: `${publicPrefix}/Order/CreateOrder`,
    PAYMENT_CALLBACK: `${publicPrefix}/ToroGo/PaymentCallback`,
    SEND_OTP_SAMLING_TORO: `${publicPrefix}/ToroGo/SendOtpSamlingToro`,
    CHECK_VOUCHER_LOYALTY: `${publicPrefix}/ToroGo/CheckVoucherLoyalty`,
    CHECK_VOUCHER_VER1003: `${publicPrefix}/ToroGo/CheckVoucherVer1003`,
    CHECK_ACQUIRE_USER: `${publicPrefix}/ToroGo/CheckAcquireUser`,
    RETRY_DROP_GOODS: `${publicPrefix}/ToroGo/RetryDropGoods`,
    UPDATE_SOCKET: `${publicPrefix}/ToroGo/UpdateSocket`,
    GET_BILL: `${publicPrefix}/ToroGo/GetBill`,
    GET_CHARITY_FUND: `${publicPrefix}/ToroGo/GetCharityFund`,
    GET_BANK: `${publicPrefix}/CashLeftOver/GetBank`,
    SAVE_CONLLECTION_BY_GIFT: `${publicPrefix}/ToroGo/SaveConllectionByGift`,
    CREATE_CASH_VOUCHER: `${publicPrefix}/ToroGo/CreateCashVoucher`,
    CHECK_CASH_VOUCHER: `${publicPrefix}/ToroGo/CheckCashVoucher`,
    CREATE_ORDER_BY_CASH_VOUCHER: `${publicPrefix}/ToroGo/CreateOrderByCashVoucher`,
    CANCEL_ORDER: `${publicPrefix}/ToroGo/CancelOrder`,
    UPDATE_TRANSACTION_REFUND: `${publicPrefix}/Order/UpdateTransactionsPaymentRefund`,
    UPDATE_TRANSACTION_PAYMENT_ORDER: `${publicPrefix}/Order/UpdateTransactionsPaymentOrder`,
  },
  GAME: {
    INIT: `${publicPrefix}/Game/InitGame`,
    GET_POLICY: `${publicPrefix}/Game/GetPolicy`,
    INFO: `${publicPrefix}/Game/GetGameInfo`,
    RESULT: `${publicPrefix}/Game/GameResult`,
    REGISTER: `${publicPrefix}/Game/RegisterMember`,
    INIT_SURVEY: `${publicPrefix}/Game/InitSurvey`,
    SAVE_SURVEY_RESULT: `${publicPrefix}/Game/SaveSurveyResult`,
    REGISTER_GAME_CODE: `${publicPrefix}/Game/RegisterGameCode`,
    CREATE_PROMOTION_GIFT_VOUCHER: `${publicPrefix}/Game/CreatePromotionGiftVoucher`,
    CHECK_GAME_CODE: `${publicPrefix}/Game/CheckGameCode`,
  },
  UPLOAD: {
    UPLOAD: `${publicPrefix}/Upload/Upload`,
  },
  CUSTOMER_CARE: {
    INIT: `${publicPrefix}/CustomerCare/InitCustomerCare`,
    SAVE: `${publicPrefix}/CustomerCare/SaveCustomerCare`,
  },
  CASH_LEFT_OVER: {
    INIT: `${publicPrefix}/CashLeftOver/CheckEToken`,
    SAVE: `${publicPrefix}/CashLeftOver/ProcessTRG`,
  },
  TRANS_TOPUP_BANK: {
    GET_BANK_LIST: `${publicPrefix}/CashLeftOver/GetBank`,
    INIT: `${publicPrefix}/TransTopupBank/GetAccountBank`,
    SAVE: `${publicPrefix}/TransTopupBank/ChangeAccountBank`,
  },
  TOPUP: {
    CREATE_TRANSACTION_CODE: `${publicPrefix}/TransTopup/CreateTransactionCode`,
  },
};

// SITE URL
export const LOCAL_PATH = {
  EMPTY: ``,
  HOME: `/`,
  BLANK: `/404`,
  CART: `/cart`,
  CARTS: `/carts`,
  PRODUCT: `/product`,
  STATUS_VM: `/vm`,
  BILL: `/bill`,
  BILL_SUCCESS: `/bill-success`,
  BILLS_FAIL: `/bill-fail`,
  LUCKY_DRAW: `/lucky-draw`,
  LUCKY_DRAW_CARD: `/lucky-lottery`,
  SQUAT_GAME: `/squat-game`,
  VIEW_VIDEO_GAME: `/view-video-game`,
  VIEW_VIDEO_GAME_CLONE: `/view-video-game-1.0.1`,
  GAME_REGISTER: `/game-register`,
  RESULT_PAYMENT: `/result-payment`,
  WAITTING: `/waitting`,
  RESULT_PAYMENT_NESCAFE: `/result-payment-nescafe`,
  CUSTOMER_CARE: `/customer-care`,
  CASH_LEFT_OVER: `/cash-left-over`,
  SURVEY: `/survey`,
  SURVEY_BEFORE: `/survey-before`,
  CHANGE_BANK: `/cb`,
  LUCKY_POSTER: `/lucky-poster`,
  LUCKY_POSTER_SERI_A: `/lucky-poster-v2`,
  LUCKY_POSTER_SERI_B: `/lucky-poster-v3`,
  LUCKY_SPECIAL: `/lucky-special`,
  LUCKY_WHEELY: `/lucky-wheely`,
  HIT_THE_MOUSE: `/hit-the-mouse`,
  HEALTH_CHECK: `/health-check`,
  CHOOSE_POSITION: `/choose-position`,
  ABOUT_KOOTORO: `/about-kootoro`,
  VENDING_MODEL: `/vending-model`,
  VENDING_MODEL_DETAIL: `/vending-model/:id`,
  QUESTION: `/question`,
  CONTACT: `/contact`,
};